//en.js
import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  resultCodeInfo: {
    "200": "Operation successful",
    "205": "Logout success",
    "500": "Operation failed",
    "401": "Not logged in or token expired",
    "402": "Wrong username or password",
    "403": "No permission",
    "404": "Parameter validation failed",
    ERRCODE_001: "Current user is unavailable",
    ERRCODE_002: "Serial number expired",
    ERRCODE_003: "Serial number is incorrect",
    EXPORTCODE: "No data to export",
    "999": "Operation failed! Please contact administrator",
  },
  verify: {
    dragTips: "Please hold the slider and drag to the far right",
    successTips: "Verification completed"
  },
  login: {
    platformName: "HRP Integrated Portal Platform",
    usernamePlaceholder: "Please enter username",
    usernameRule: "Username must be 2-10 characters",
    passwordPlaceholder: "Please enter password",
    passwordRule: "Password must be 6-10 characters",
    phonePlaceholder: "Please enter phone number",
    phoneRule: "Please enter a valid phone number",
    verificationCodePlaceholder: "Please enter verification code",
    verificationCodeRule: "Please enter a valid verification code",
    loginButton: "Login",
    loginByPhone: "Login with phone number",
    loginByUsername: "Login with username and password",
    forgotPassword: "Forgot password?",
    privacyPolicy: "Privacy Policy",
    agreePrivacy: "Clicking login means you agree to",
    register: "User registration entry",
    verifyFirst: "Please verify first",
    pleaseEnterUsername: "Please enter username",
    pleaseEnterPassword: "Please enter password",
    pleaseEnterPhone: "Please enter phone number",
    sendVerificationCode: "Send code",
    browserSupport: "This website does not support IE browser. Supported browsers:",
    browserNote: "Please use high-speed mode for browsers like 360, QQ, Sogou, etc.",
    google: "Google",
    firefox: "Firefox",
    edge: "Edge",
    opera: "Opera",
    thirdPartyLogin: "Third-party quick login",
    feedbackBox: "Dean's suggestion box"
  },
  common: {
    switchLang: "切换中文",
    // Common buttons
    addBtn: "Add",
    editBtn: "Edit",
    deleteBtn: "Delete",
    searchBtn: "Search",
    resetBtn: "Reset",
    cancelBtn: "Cancel",
    closeBtn: "Close",
    saveBtn: "Save",
    submitBtn: "Submit",
    exportBtn: "Export",
    confirmBtn: "Confirm",
    returnBtn: "Back",
    // Yes/No
    yes: "Yes",
    no: "No",
    // Common labels
    tableSortNum: "No.",
    operation: "Operation",
    select: "Please select",
    // Common states
    normalState: "Normal",
    stopState: "Disabled",
    enable: "Enabled",
    disable: "Disabled",
    all: "All",
    allOption: "-- All--",
    // Common tips
    tips: "Tips",
    confirmDelete: "Are you sure you want to delete?",
    deleteTitle: "Confirmation",
    // Operation success/fail messages
    delSuccess: "Deleted successfully",
    delFail: "Delete failed",
    addSuccess: "Added successfully",
    addFail: "Add failed",
    cancelSuccess: "Canceled successfully",
    cancelFail: "Cancel failed",
    editSuccess: "Edited successfully",
    editFail: "Edit failed",
    saveSuccess: "Saved successfully",
    saveFail: "Save failed",
    operationSuccess: "Operation successful",
    operationFail: "Operation failed",
    // Form validation
    message: {
      mustInput: "This field is required",
      mustChoose: "This field must be selected",
    },
    ruleBlurMsg: "Please enter",
    ruleSelectMsg: "Please select",
    // Others
    popoverTitle: "Show column filter",
    searchFailMsg: "Query information not found",
    updator: "Updater",
    updateAt: "Update At",
    creator: "Creator",
    createAt: "Create At",
    gobackLevel: "Back",
  },
  ...enLocale
}
export default en;
